import { render, staticRenderFns } from "./traveler-label.vue?vue&type=template&id=ae6e75bc&scoped=true&"
import script from "./traveler-label.vue?vue&type=script&lang=js&"
export * from "./traveler-label.vue?vue&type=script&lang=js&"
import style0 from "./traveler-label.vue?vue&type=style&index=0&id=ae6e75bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6e75bc",
  null
  
)

export default component.exports